import React, { useState } from 'react';
function Action(props) {

    let [score, updateScore] = useState(4444)
    let [likesState, updateLikesState] = useState(parseInt(props.like))
    let [dislikesState, updateDislikesState] = useState(parseInt(props.dislikes))
    

    let changeValue=function(){
        console.log("changeValue called")
        // updateScore(score+1)
        updateLikesState(likesState+1)
    }
    let changeDislikes=function(){
        console.log("changeValue called")
        // updateScore(score+1)
        updateDislikesState(dislikesState+1)
    }

    return (
        <div>
            <h3>Score: {score}</h3>
            <button onClick={changeValue}>Likes{likesState}</button>
            <button onClick={changeDislikes}>Dislikes{dislikesState}</button>
        </div>
      );
}

export default Action;